
import React from 'react';
import AuctionExplainerSection from '../content/AuctionExplainerSection';
import SecuritySection from '../content/SecuritySection';
import PricingSection from '../content/PricingSection';

const ServiceSections = () => {
  return (
    <>
      <AuctionExplainerSection />
      <SecuritySection />
      <PricingSection />
    </>
  );
};

export default ServiceSections;
